import hoursOptions from '@/febos/global/billing/settings/AvailableHour';

const filterViewsCompany = {};
const filterViews = {
  general: {
    filtrosFijos: [
      {
        nombre: 'empresa id',
        campo: 'empresaId',
        tipo: 'text',
        // eslint-disable-next-line no-template-curly-in-string
        valor: '${empresaId}'
      }
    ],
    filtrosHabilitados: [
      {
        nombre: 'Estado',
        campo: 'emisor.status',
        tipo: 'multi',
        valor: [],
        opciones: {
          true: 'Activo',
          false: 'Inactivo'
        }
      },
      {
        nombre: 'Receptor Rut',
        campo: 'receptor.iut',
        tipo: 'texto',
        valor: ''
      },
      {
        nombre: 'Fecha facturación',
        campo: 'emisor.dayType',
        tipo: 'multi',
        valor: '',
        opciones: {
          P: 'Primer día',
          U: 'Último día',
          otro: 'Otro día'
        }
      },
      {
        nombre: 'Tipo factura',
        campo: 'emisor.type',
        tipo: 'multi',
        valor: '',
        opciones: {
          33: 'Afecta',
          34: 'Exenta'
        }
      },
      {
        nombre: 'Tipo de monto',
        campo: 'detalle.bruto',
        tipo: 'multi',
        valor: '',
        opciones: {
          true: 'Bruto',
          false: 'Neto'
        }
      },
      {
        nombre: 'Es en cuotas',
        campo: 'emisor.esEnCuota',
        tipo: 'multi',
        valor: '',
        opciones: {
          true: 'Si',
          false: 'No'
        }
      },
      {
        nombre: 'Se guarda como borrador',
        campo: 'emisor.saveAsDraf',
        tipo: 'multi',
        valor: '',
        opciones: {
          true: 'Si',
          false: 'No'
        }
      },
      {
        nombre: 'Día facturación',
        campo: 'emisor.day',
        tipo: 'texto',
        valor: ''
      },
      {
        nombre: 'Hora de ejecución',
        campo: 'emisor.hour',
        tipo: 'multi',
        valor: '',
        opciones: hoursOptions.reduce((acc, {
          label,
          value
        }) => ({
          ...acc,
          [value]: label
        }), {})
      }
    ]
  }
};

export default {
  data() {
    return filterViews;
  },
  methods: {
    getFilterViewLetty(view, iutCompany) {
      let filtros = { ...filterViews[view] };
      if (filterViewsCompany[iutCompany] && filterViewsCompany[iutCompany][view]) {
        filtros = {
          filtrosFijos: [
            ...filterViewsCompany[iutCompany][view].filtrosFijos || [],
            ...filtros.filtrosFijos || []
          ],
          filtrosHabilitados: [
            ...filterViewsCompany[iutCompany][view].filtrosHabilitados || [],
            ...filtros.filtrosHabilitados || []
          ]
        };
        if (filterViewsCompany[iutCompany][view].filtroFijoABorrar) {
          filtros = {
            ...filtros,
            filtrosFijos: filtros.filtrosFijos.filter(
              (filtro) => !filterViewsCompany[iutCompany][view].filtroFijoABorrar.includes(
                filtro.campo
              )
            )
          };
        }
        if (filterViewsCompany[iutCompany][view].filtrosHabilitadosABorrar) {
          filtros = {
            ...filtros,
            filtrosHabilitados: filtros.filtrosHabilitados.filter(
              (filtro) => !filterViewsCompany[iutCompany][view].filtrosHabilitadosABorrar.includes(
                filtro.campo
              )
            )
          };
        }
      }
      if (filterViewsCompany[iutCompany] && filterViewsCompany[iutCompany].renombres) {
        const { renombres } = filterViewsCompany[iutCompany];
        Object.keys(renombres)
          .forEach((key) => {
            /* eslint-disable no-unused-expressions */
            filtros.filtrosHabilitados?.forEach((filtro) => {
              if (filtro.campo === key) {
                /* eslint-disable no-param-reassign */
                filtro.nombre = renombres[key];
              }
            });
          });
      }
      return filtros;
    }
  }
};
